import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type CustomiseOptionsTotalClasses = 'optionsContainer' | 'optionsTotalValue' | 'optionsTotalLabel';

const customiseOptionsTotalStyles = makeStyles<ISpcTheme, CustomiseOptionsTotalClasses>(
  theme => ({
    optionsContainer: {
      marginBottom: '24px',
    },
    optionsTotalValue: {
      color: theme.palette.secondary.main,
      fontFamily: theme.typography.fontFamily2,
      paddingRight: theme.spacing(0.5),
    },
    optionsTotalLabel: {
      color: theme.palette.secondary.main,
    },
  }),
  { name: 'Customise_simpleBrands_OptionsTotal' },
);

export default customiseOptionsTotalStyles;
